import { BUILDINGS } from '../../types';
// export const setBuildings = (data) => async dispatch => { dispatch({ type: BUILDINGS, payload: data })}
export const setBuildings = (data) => ({ type: BUILDINGS, payload: data });
